__turbopack_context__.v({
  "header": "Header-module__aO477a__header",
  "logo": "Header-module__aO477a__logo",
  "logoOnDark": "Header-module__aO477a__logoOnDark",
  "logoOnLight": "Header-module__aO477a__logoOnLight",
  "mobileLink": "Header-module__aO477a__mobileLink",
  "mobileMenu": "Header-module__aO477a__mobileMenu",
  "navLink": "Header-module__aO477a__navLink",
  "navLinkActive": "Header-module__aO477a__navLinkActive",
});
